import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JobtitleService {
  constructor(private http: HttpClient) { }

  remote() {
    return this.http.get<any[]>(environment.app.apiUrl + 'jobtitle/remote').toPromise();
  }

  search(criteria: any) {
    var params = JSON.parse(JSON.stringify(criteria));
    return this.http.get<any[]>(environment.app.apiUrl + 'jobtitle/search', { params }).toPromise();
  }
  adminSearch(criteria: any) {
    return this.http.post<any[]>(environment.app.apiUrl + 'jobtitle/admin/search', criteria).toPromise();
  }

  save(jobtitle: any) {
    return this.http.post(environment.app.apiUrl + 'jobtitle/save', jobtitle).toPromise();
  }

  delete(jobtitleId: string) {
    return this.http.delete(environment.app.apiUrl + 'jobtitle/' + jobtitleId).toPromise();
  }

  import(list: string[]) {
    return this.http.post(environment.app.apiUrl + 'jobtitle/admin/import', list).toPromise();
  }
  getSampleSeekers(id: any, from: number, limit: number, order: string, location: any) {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/samples/seeker/${id}`, { from, limit, order, location }).toPromise();
  }
  getSampleJobs(id: any, from: number, limit: number, order: string, location: any, debug: boolean) {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/samples/job/${id}`, { from, limit, order, location, debug }).toPromise();
  }
  getTaggedSeekers(id: any, from: number, limit: number, order: string, location: any) {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/tagged/seeker/${id}`, { from, limit, order, location }).toPromise();
  }
  getTaggedJobs(id: any, from: number, limit: number, order: string, location: any) {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/tagged/job/${id}`, { from, limit, order, location }).toPromise();
  }
  setStatistics(id: any): any {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/set-statistics/${id}`, null).toPromise();
  }
  getSuggestions(id: any): any {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/suggestions/${id}`, null).toPromise();
  }
  removeJobTags(id: any): any {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/remove-job-tags/${id}`, null).toPromise();
  }
  removeSeekerTags(id: any): any {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/remove-seeker-tags/${id}`, null).toPromise();
  }
  tagJobs(id: any): any {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/tag-jobs/${id}`, null).toPromise();
  }
  tagSeekers(id: any): any {
    return this.http.post<any>(environment.app.apiUrl + `jobtitle/admin/tag-seekers/${id}`, null).toPromise();
  }

  // skills(keyword: string = "") {
  //   return this.http.post<any>(environment.app.apiUrl + 'jobtitle/skills', JSON.stringify(keyword)).toPromise();
  // }
  // educations(keyword: string = "") {
  //   return this.http.post<any>(environment.app.apiUrl + 'jobtitle/educations', JSON.stringify(keyword)).toPromise();
  // }

  pureData(count: number = 6000, minDocument = 1, reload = false) {
    return this.http.get<any>(environment.app.apiUrl + `jobtitle/data/${count}/${minDocument}/${reload}`).toPromise();
  }

  saveLink(field: string, relation: any) {
    return this.http.post(environment.app.apiUrl + 'jobtitle/' + field.toLowerCase(), relation).toPromise();
  }
  deleteLink(field: string, relationId: string) {
    return this.http.delete(environment.app.apiUrl + 'jobtitle/' + field.toLowerCase() + '/' + relationId).toPromise();
  }

  translate(field: string, key: string, ...to: string[]) {
    return this.http.post(environment.app.apiUrl + `jobtitle/translate/${field}`, { key, to }).toPromise();
  }

  // operator
  getAdminSuggestions(type: string): Promise<string[]> {
    return this.http.get<string[]>(environment.app.apiUrl + 'jobtitle/admin/suggest/' + type).toPromise();
  }

  browseAlphabets() {
    return this.http.get<string[]>(environment.app.apiUrl + 'jobtitle/browse/alphabets').toPromise();
  }

}
